<template>
    <div class="loader">
        <div class="container">
            <div v-show="loadingState"  class="animation"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        'loadingState': {required: true}
    }
    
}
</script>

<style lang="css" scoped>

    .mobile-filter-hide .loader{
        padding-top: 0;
        width: auto;
    }
    .loader {
        width: 100%;
        margin-bottom: 25px;
        z-index: 9999;
    }
    .loader .container {
        width: 70px;
        height: 35px;
        overflow: hidden;
        margin: 0 auto;
    }

    .mobile-filter-hide .loader .container .animation{
        width: 30px;
        height: 30px;
    }

    .loader .container .animation {    
        width: 30px;
        height: 30px;
        border-style: solid;
        border-top-color: rgb(255,193,7);
        border-right-color: rgb(255,193,7);
        border-left-color: transparent;
        border-bottom-color: transparent;
        border-radius: 50%;
        box-sizing: border-box;
        animation: rotate 2s ease-in-out infinite;
        transform: rotate(-400deg);
    }
    @keyframes rotate {
        0% { border-width: 10px; }
        25% { border-width: 3px; }
        50% { 
            transform: rotate(115deg); 
            border-width: 10px;
        }
        75% { border-width: 3px;}
        100% { border-width: 10px;}
    }
    
</style>

